import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginInfoComponent} from "./login-info/login-info.component";
import {LogoutComponent} from "./logout/logout.component";
import { Ng2ImgFallbackModule } from 'ng2-img-fallback';

@NgModule({
  imports: [CommonModule, Ng2ImgFallbackModule],
  declarations: [LoginInfoComponent, LogoutComponent],
  exports: [LoginInfoComponent, LogoutComponent]
})
export class UserModule{}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.module.ts